// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function MapPinIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 8a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 8a3 3 0 1 1 0-5.999A3 3 0 0 1 16 16Zm0-14A11.013 11.013 0 0 0 5 13c0 3.925 1.814 8.085 5.25 12.031a31.772 31.772 0 0 0 5.181 4.788 1 1 0 0 0 1.148 0 31.775 31.775 0 0 0 5.171-4.788C25.181 21.085 27 16.925 27 13A11.012 11.012 0 0 0 16 2Zm0 25.75C13.934 26.125 7 20.156 7 13a9 9 0 0 1 18 0c0 7.154-6.934 13.125-9 14.75Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
